import React, { useState } from 'react';
import { loginUser } from '../api';

function Login({ onLogin }) {
  const [userId, setUserId] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const trimmedUserId = userId.trim();
      const trimmedPassword = password;
      const result = await loginUser(trimmedUserId, trimmedPassword);
      if (result.success) {
        onLogin(result.user);
      } else {
        setError(result.error || 'Login failed');
      }
    } catch (err) {
      setError(err.error || 'Login failed. Please check your User ID and password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <p className="brand">What You Asked For CRM</p>
      <h1>Sign In</h1>
      <p className="subtitle">Enchanted Parks guest services</p>

      {error && <div className="error">{error}</div>}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="userId">User ID</label>
          <input
            type="text"
            id="userId"
            value={userId}
            onChange={(e) => setUserId(e.target.value)}
            placeholder="Enter your User ID"
            required
            autoFocus
          />
        </div>

        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
            required
          />
        </div>

        <button type="submit" disabled={loading}>
          {loading ? 'Logging in...' : 'Login'}
        </button>
      </form>

      <p className="subtitle" style={{ marginTop: '20px', textAlign: 'center' }}>
        Demo: <strong>LEAD01</strong> (leadership) · <strong>PARK01</strong> (parking) ·{' '}
        <strong>TICKET01</strong> (gate) · <strong>USER001</strong> (park) ·{' '}
        <strong>CORP001</strong> (corporate)
      </p>
    </div>
  );
}

export default Login;
